import dayjs, { ConfigType } from "dayjs";

import useNow from "@/hooks/useNow";
import { formatDuration } from "@/shared/formatters";

export function ElapsedTime(props: { startedAt: ConfigType }) {
  const now = useNow(1000);
  return (
    <span>
      {formatDuration(now.valueOf() - dayjs(props.startedAt).valueOf())}
    </span>
  );
}
